module.exports = __webpack_public_path__ + "static/media/chris.teas_photography-IG.4c0a98cb.PNG";